import mothersDayGuid from "@assets/images/GUIDScreens/mothers-day-guid.avif";
import type { GUIDScreenProps } from "./types";

function MothersDay({ line1, line2 }: GUIDScreenProps) {
  return (
    <svg viewBox="0 0 800 340" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#mothers-day-guid-clip)">
        <image
          href={mothersDayGuid.src}
          width="800"
          height="340"
          preserveAspectRatio="xMidYMid slice"
        />
      </g>
      <text
        x="400"
        y="160"
        style={{ fill: "#1F2022" }}
        fontSize="61"
        textAnchor="middle"
        fontFamily="'Mori Gothic', Arial"
        fontWeight="600"
      >
        {line1 || ""}
      </text>
      <text
        x="400"
        y="226"
        style={{ fill: "#1F2022" }}
        fontSize="50"
        textAnchor="middle"
        fontFamily="'Mori Gothic', Arial"
        fontWeight="600"
      >
        {line2 || ""}
      </text>
      <defs>
        <clipPath id="mothers-day-guid-clip">
          <rect width="800" height="340" rx="54" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default MothersDay;
